import useTranslate from 'app/i18n/useTranslate';

import type { UseTranslation } from './types';

const useTranslation: UseTranslation = () => {
    const t = useTranslate('serviceIntervalFields');

    return {
        OEM_DEFAULT: ({ value }: { value: string }) => t('oemDefault', { value }),
        RESET_TO_DEFAULT: t('resetToDefault'),
        UNIT_LABELS: {
            CYCLES: t('unitCycles'),
            FLIGHTS: t('unitFlights'),
            HOURS: t('unitHours')
        },
        UNIT_NAMES: {
            CYCLES: t('chargeCycles'),
            FLIGHTS: t('flights'),
            HOURS: t('flightHours')
        }
    };
};

export default useTranslation;
